import { createRpcMutation } from './factory'

export const useUpdateOrganizationPoints = createRpcMutation({
   fn: 'update_organizationpoints',
   successKey: 'info.organizationpoints-updated',
   invalidates: (props) => [
      ['organizationpoints-grid'],
      ['organization', { id: props.p_organization_id }],
   ],
})
